import { configureStore } from '@reduxjs/toolkit';

// Example slice reducer (you'll replace this with your slices)
import homeReducer from './slices/homeSlice';
import superAdminReducer from '../Screen/Superadmin/superAdminSlice'
import snackbarReducer from './slices/snackbarSlice'
import loaderReducer from './slices/loaderSlice'
export const store = configureStore({
  reducer: {
    homeReducer: homeReducer,
    superAdminReducer: superAdminReducer,
    snackbar: snackbarReducer,
    Loader: loaderReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;